import { useMutation, useQueryClient } from "@tanstack/react-query";
import { connectedAppsKeys } from "Api/Queries/Sso/useConnectedAppsQuery";
import { deleteSsoConnectedAppsClientId } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useRevokeConnectedAppMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((clientId: string) =>
      deleteSsoConnectedAppsClientId(clientId),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: connectedAppsKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
